import { User } from 'lucide-react';
import { useAuthStore } from '../stores/auth';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';

export default function Profile() {
  const { t } = useTranslation();
  const { user } = useAuthStore();

  return (
    <Layout title={t('profile.personal_info', 'Personal Information')}>
      <div className="container mx-auto py-10 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#00C2CB] to-[#6A98F0] mb-8">
            {t('profile.personal_info', 'Personal Information')}
          </h2>

          {/* Profile content */}
          <div className="bg-[#1A2235] rounded-xl p-6 shadow-lg">
            {/* User info */}
            <div className="flex items-start gap-6 mb-8 flex-wrap md:flex-nowrap">
              <div className="w-20 h-20 rounded-full overflow-hidden bg-[#253045] flex items-center justify-center flex-shrink-0">
                <User size={40} className="text-[#00C0FF]" />
              </div>
              <div className="flex-1">
                <h2 className="text-2xl font-semibold text-white mb-1">{user?.name}</h2>
                <p className="text-[#00C0FF]">{user?.email}</p>
              </div>
            </div>

            {/* User details */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Role */}
              <div className="bg-[#253045] rounded-lg p-4">
                <h3 className="text-[16px] font-medium text-[#00C0FF]">{t('profile.role')}</h3>
                <div className="mt-2">
                  <p className="text-white text-[14px]">{user?.role || 'User'}</p>
                </div>
              </div>

              {/* Organization */}
              <div className="bg-[#253045] rounded-lg p-4">
                <h3 className="text-[16px] font-medium text-[#00C0FF]">{t('profile.organization')}</h3>
                <div className="mt-2">
                  <p className="text-white text-[14px]">{user?.organization?.name || 'N/A'}</p>
                  {user?.organization?.description && (
                    <p className="text-gray-300 text-[12px] mt-2">{user.organization.description}</p>
                  )}
                </div>
              </div>

              {/* Account Status */}
              <div className="bg-[#253045] rounded-lg p-4">
                <h3 className="text-[16px] font-medium text-[#00C0FF]">{t('profile.account_status')}</h3>
                <div className="mt-2">
                  <p className="text-white text-[14px]">
                    {user?.is_active ? t('profile.status.active') : t('profile.status.inactive')}
                  </p>
                </div>
              </div>

              {/* Groups */}
              <div className="bg-[#253045] rounded-lg p-4">
                <h3 className="text-[16px] font-medium text-[#00C0FF]">{t('profile.groups')}</h3>
                <div className="mt-2">
                  {user?.groups && user.groups.length > 0 ? (
                    <div className="space-y-2">
                      {user.groups.map((group) => (
                        <div key={group.id} className="bg-[#1A2235] rounded p-2">
                          <p className="text-white font-medium text-[14px]">{group.name}</p>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-white text-[14px]">{t('profile.no_groups')}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
